// extracted by mini-css-extract-plugin
export default {"overlay":"StandardModal-module__overlay___tv3JZ","modal":"StandardModal-module__modal___hYTO8"};